<div *ngIf="details && type === 'wc'" id="itemcard" style="font-size: 14px">
  <div class="mb-1">
    <span style="font-weight: 500">Brand: </span>{{ details.brand }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Generic: </span>{{ details.generic }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Strength: </span>{{ details.strength }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Thera Class: </span>{{ details.thera_name }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Legal Class: </span>{{ details.legal }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Rx Status: </span>{{ details.rx_type }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Contract GPO: </span
    >{{ details.contract_name_gpo }}<br />
    {{ details.contract_start_gpo }} - {{ details.contract_end_gpo }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Contract PHS: </span
    >{{ details.contract_name_340b }}<br />
    {{ details.contract_start_340b }} - {{ details.contract_end_340b }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Storage: </span
    >{{ details.storage_condition }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Route: </span
    >{{ details.route_of_administration }}
  </div>
</div>

<div *ngIf="details && type === 'ndc'" id="itemcard" style="font-size: 15px">
  <div class="mb-1">
    <span style="font-weight: 500">Description: </span>{{ details.description }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">NDC: </span>{{ details?.ndc }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Brand: </span>{{ details.bn }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Generic: </span>{{ details.gnn }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Strength: </span>{{ details.str }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Thera Class: </span>{{ details.tc_desc }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Legal Class: </span>{{ details.schedule }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Storage: </span>{{ details.storage_cond }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Route: </span>{{ details.route }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Unit Size: </span
    >{{ details.listing_package_size }}
  </div>
  <div class="mb-1">
    <span style="font-weight: 500">Package Type: </span
    >{{ details.listing_package_type }}
  </div>
</div>

<div
  *ngIf="!details"
  id="itemcard"
  class="m-auto"
  style="display: flex; justify-content: center; align-items: center"
>
  <dx-load-indicator
    id="large-indicator"
    height="60"
    width="60"
  ></dx-load-indicator>
  <div>Waiting for data...</div>
</div>
